import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import { ProfilePage } from "@/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/profile/")({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	return (
		<DashboardLayout>
			<ProfilePage />
		</DashboardLayout>
	);
}
